export const assetLoading = {
  LOCK: 'LOCK',
};

export const checklistLoading = {
  COURSE_BEST_PRACTICES: 'COURSE_BEST_PRACTICES',
  COURSE_LAUNCH: 'COURSE_LAUNCH',
};
